export default function getLearnMoreLink(helpId: string): string {
    return `https://support.microsoft.com/en-us/office/brief-intro-to-viva-topics-53620e12-ae00-4523-87cf-e935ae77d541?ns=spostandard&version=16&syslcid=1033&uilcid=1033&appver=spo160&helpid=${helpId}`;
}
